var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMcpForAiAgents = function SvgMcpForAiAgents(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#mcp-for-ai-agents_svg__a)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.429,
    d: "m25.143 2.857 2.02 5.253c.484 1.257.726 1.886 1.102 2.415.333.468.742.877 1.21 1.21.53.377 1.158.618 2.415 1.102l5.253 2.02-5.253 2.02c-1.257.484-1.886.726-2.414 1.102a5.1 5.1 0 0 0-1.211 1.21c-.376.53-.618 1.158-1.101 2.415l-2.02 5.253-2.021-5.253c-.484-1.257-.726-1.886-1.102-2.414a5.2 5.2 0 0 0-1.21-1.211c-.53-.376-1.158-.618-2.415-1.101l-5.253-2.02 5.253-2.021c1.257-.484 1.886-.726 2.415-1.101a5.1 5.1 0 0 0 1.21-1.211c.376-.53.618-1.158 1.102-2.415z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.429,
    d: "m10.572 21.714 1.345 2.69c.455.91.682 1.365.986 1.76q.407.527.934.933c.394.304.85.532 1.76.987l2.689 1.345-2.69 1.344c-.91.455-1.365.683-1.76.987q-.526.406-.933.933c-.304.395-.531.85-.987 1.76l-1.344 2.69-1.345-2.69c-.455-.91-.683-1.365-.987-1.76a5 5 0 0 0-.933-.933c-.395-.304-.85-.532-1.76-.987l-2.69-1.344 2.69-1.345c.91-.455 1.365-.683 1.76-.987.35-.27.663-.584.933-.933.304-.395.532-.85.987-1.76z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "mcp-for-ai-agents_svg__a",
    x1: 35.014,
    x2: -12.951,
    y1: 3.52,
    y2: 21.884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92E7F"
  })))));
};
export default SvgMcpForAiAgents;